<h2 mat-dialog-title>{{isEdit ? 'Verteiler bearbeiten' : 'Neuer Verteiler / Anlage'}}</h2>

<mat-dialog-content>
  <div class="form-grid">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Bezeichnung</mat-label>
      <input matInput [(ngModel)]="equipment.name" required placeholder="z.B. Hauptverteiler EG">
      <mat-icon matPrefix>electrical_services</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Standort / Ort</mat-label>
      <input matInput [(ngModel)]="equipment.location" placeholder="z.B. Erdgeschoss, Raum 102">
      <mat-icon matPrefix>place</mat-icon>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!equipment.name?.trim() || saving">
    <mat-spinner *ngIf="saving" diameter="18" class="btn-spinner"></mat-spinner>
    {{isEdit ? 'Speichern' : 'Anlegen'}}
  </button>
</mat-dialog-actions>
